const MALAYSIA_TZ = "Asia/Kuala_Lumpur";

export function deliveryDateStamp(value) {
  if (value == null || value === "") return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: MALAYSIA_TZ,
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  }).formatToParts(date);
  const day = parts.find((part) => part.type === "day")?.value;
  const month = parts.find((part) => part.type === "month")?.value;
  const year = parts.find((part) => part.type === "year")?.value;
  if (!day || !month || !year) return "";
  return `${day}${month}${year}`;
}

export function deliveryUrlPrefix(dateValue) {
  const stamp = deliveryDateStamp(dateValue);
  return stamp ? `/deliveries/${stamp}/` : "/deliveries/";
}

export function deliveryHref(item) {
  const slug = String(item?.slug || "").trim();
  if (!slug) return "/deliveries";
  const stamp = deliveryDateStamp(item?.deliveryDate);
  return stamp ? `/deliveries/${stamp}/${slug}` : `/deliveries/${slug}`;
}

export function deliveryPublicPath(item) {
  const slug = String(item?.slug || "").trim();
  if (!slug) return "";
  return deliveryHref(item);
}
